var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlaceholder64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.192 14.5h29.616c2.675 0 3.645.278 4.623.801a5.452 5.452 0 012.268 2.268c.523.978.801 1.948.801 4.623v19.616c0 2.675-.278 3.645-.801 4.623a5.452 5.452 0 01-2.268 2.268c-.978.523-1.948.801-4.623.801H17.192c-2.675 0-3.645-.278-4.623-.801a5.452 5.452 0 01-2.268-2.268c-.523-.978-.801-1.948-.801-4.623V22.192c0-2.675.278-3.645.801-4.623a5.452 5.452 0 012.268-2.268c.978-.523 1.948-.801 4.623-.801z",
    id: "image-placeholder-64_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5 32h0v9.808c0 2.675-.278 3.645-.801 4.623a5.452 5.452 0 01-2.268 2.268c-.978.523-1.948.801-4.623.801H17.192c-2.675 0-3.645-.278-4.623-.801a5.452 5.452 0 01-2.268-2.268c-.523-.978-.801-1.948-.801-4.623V32h0",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 32h0v-9.808c0-2.675-.278-3.645-.801-4.623a5.452 5.452 0 00-2.268-2.268c-.978-.523-1.948-.801-4.623-.801H17.192c-2.675 0-3.645.278-4.623.801a5.452 5.452 0 00-2.268 2.268c-.523.978-.801 1.948-.801 4.623V32h0",
    stroke: "#000",
    strokeWidth: 3,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "image-placeholder-64_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-placeholder-64_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.822 32.225L38.429 43.34l2.883-2.998c1.958-2.036 5.045-1.964 6.906.174l9.496 10.907c0 1.803-3.857 2.614-3.857 2.614H28.143l2.553-2.656-20.553-.055S5 51.551 5 50.129l15.882-17.796c1.88-2.106 4.984-2.157 6.94-.108z",
    stroke: "#000",
    strokeWidth: 3,
    fillOpacity: 0.15,
    fill: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#image-placeholder-64_svg__b)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    mask: "url(#image-placeholder-64_svg__b)",
    cx: 43,
    cy: 26.041,
    rx: 5,
    ry: 5.041
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder64);
export default __webpack_public_path__ + "static/media/image-placeholder-64.530f5d63.svg";
export { ForwardRef as ReactComponent };